import { createApp } from 'vue'
import App from './App.vue'

// Bootstrap
import 'bootstrap/dist/css/bootstrap.min.css'
import 'bootstrap'

// Vuetify
import 'vuetify/styles'
import { createVuetify } from 'vuetify'
import * as components from 'vuetify/components'
import * as directives from 'vuetify/directives'
import '@mdi/font/css/materialdesignicons.css'

// Toast notifications
import Toast from 'vue-toastification'
import 'vue-toastification/dist/index.css'

// Router & Store
import router from './router'
import store from './store'

const vuetify = createVuetify({
  components,
  directives,
  theme: {
    defaultTheme: 'light'
  },
  defaults: {
    VOverlay: {
      // Configurar z-index para evitar conflictos con el tour
      zIndex: 2000,
      scrollStrategy: 'block'
    },
    VDialog: {
      // Configuraciones específicas para diálogos
      scrollStrategy: 'block',
      zIndex: 2100
    },
    VMenu: {
      // Configuraciones específicas para menús
      zIndex: 2200
    },
    VTooltip: {
      // Configuraciones específicas para tooltips
      zIndex: 2300
    }
  }
})

// Toast configuration
const toastOptions = {
  position: 'top-right',
  timeout: 5000,
  closeOnClick: true,
  pauseOnFocusLoss: true,
  pauseOnHover: true,
  draggable: true,
  draggablePercent: 0.6,
  showCloseButtonOnHover: false,
  hideProgressBar: false,
  closeButton: 'button',
  icon: true,
  rtl: false
}

// Suprimir el warning de ResizeObserver que no afecta la funcionalidad
const originalError = console.error
console.error = (...args) => {
  if (typeof args[0] === 'string' && args[0].includes('ResizeObserver loop completed')) {
    return
  }
  originalError.apply(console, args)
}

const app = createApp(App)

// Error handler global para capturar errores de Vuetify
app.config.errorHandler = (err, vm, info) => {
  console.error('Vue Error:', err)
  console.error('Component:', vm)
  console.error('Info:', info)
  
  // Si es un error relacionado con classList, intentar recuperarse
  if (err.message && err.message.includes('classList')) {
    console.warn('classList error detected, attempting to recover...')
    return
  }
}

app.use(store)
app.use(router)
app.use(vuetify)
app.use(Toast, toastOptions)

app.mount('#app')
